import { getUser } from "auth/security/securityUtils";
import { settings } from "../../app/settings";

export const getUserData = () => {
  const identityData = getUser();
  let validJson = false;
  try {
    JSON.parse(identityData);
    validJson = true;
  } catch (error) {}
  return identityData && validJson ? JSON.parse(identityData) : null;
};

export const checkPermission = (permissions, permission) => {
  if (settings.noAuth === true || !permission) {
    return true;
  }

  if (settings.usesCustomPermissionValidator) {
    return settings.permissionsValidator(permissions, permission);
  }

  if (permissions?.isAdmin) {
    return true;
  }

  if (Array.isArray(permission)) {
    return permission.some(p => permissions?.includes(p));
  }

  return permissions?.includes(permission);
};

export const filterByPermissions = (resources, userPermissions) => {
  if (settings.noAuth === true) {
    userPermissions = {
      isAdmin: true,
    };
  }

  if (!userPermissions) return [];

  const list = [];

  resources.forEach(resource => {
    if (!checkPermission(userPermissions, resource.permission)) {
      return;
    }

    if (!resource.subMenu) {
      list.push(resource);
      return;
    }

    const hasAvailableSubmenus = resource.subMenu.some(subResource => {
      return subResource.isMenu && checkPermission(userPermissions, subResource.permission);
    });

    if (hasAvailableSubmenus) {
      resource.subMenu = filterByPermissions(resource.subMenu, userPermissions);
      list.push(resource);
    }
  });

  return list;
};
